<template>
  <div
    v-if="!routeObject.hidden && routeObject.children"
    class="menu-wrapper"
  >

    <router-link
      v-if="hasOneShowingChild(routeObject.children) && !onlyOneChild.children && !routeObject.alwaysShow"
      :to="resolvePath(onlyOneChild.path)"
    >
      <el-menu-item
        :index="resolvePath(onlyOneChild.path)"
        :class="{'submenu-title-noDropdown':!isNest}"
      >
        <font-awesome-icon
          v-if="onlyOneChild.meta && onlyOneChild.meta.icon"
          :icon="onlyOneChild.meta.icon"
          class="font-awesome-icon"
        />
        <span
          v-if="onlyOneChild.meta && onlyOneChild.meta.title"
          slot="title"
        >{{ generateTitle(onlyOneChild.meta.title) }}</span>
      </el-menu-item>
    </router-link>

    <el-submenu
      v-else
      :index="routeObject.name || routeObject.path"
    >
      <template slot="title">
        <template v-if="isNest">
          <strip-bar
            v-for="i in level"
            :key="i"
            :level="i - 1"
          />
        </template>
        <font-awesome-icon
          v-if="routeObject.meta && routeObject.meta.icon"
          :icon="routeObject.meta.icon"
          class="font-awesome-icon"
        />
        <span
          v-if="routeObject.meta && routeObject.meta.title"
          slot="title"
        >{{ generateTitle(routeObject.meta.title) }}</span>
      </template>

      <template v-for="child in routeObject.children">
        <template v-if="!child.hidden">
          <sidebar-item
            v-if="child.children && child.children.length > 0"
            :level="level + 1"
            :is-nest="true"
            :route-object="child"
            :key="child.path"
            :base-path="resolvePath(child.path)"
            class="nest-menu"
          />

          <router-link
            v-else
            :to="resolvePath(child.path)"
            :key="child.name"
          >
            <el-menu-item :index="resolvePath(child.path)">
              <strip-bar
                v-for="i in level + 1"
                :key="i"
                :level="i - 1"
              />
              <font-awesome-icon
                v-if="child.meta && child.meta.icon"
                :icon="child.meta.icon"
                class="font-awesome-icon"
              />
              <span
                v-if="child.meta && child.meta.title"
                slot="title"
              >{{ generateTitle(child.meta.title) }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </template>
    </el-submenu>

  </div>
</template>

<script>
import path from 'path'
import StripBar from './StripBar.vue'
import generateTitle from '../../../../utils/i18n'

export default {
  name: 'SidebarItem',
  components: {
    StripBar,
  },
  props: {
    routeObject: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: '',
    },
    level: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      onlyOneChild: null,
    }
  },
  methods: {
    hasOneShowingChild(children) {
      const showingChildren = children.filter((routeObject) => {
        if (routeObject.hidden) {
          return false
        }
        // temp set(will be used if only has one showing child )
        this.onlyOneChild = routeObject
        return true
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    resolvePath(...paths) {
      return path.resolve(this.basePath, ...paths)
    },
    generateTitle,
  },
}
</script>

<style lang="scss" scoped>

.font-awesome-icon {
  margin-right: 5px;
}
</style>

